import { render } from "./Faq.vue?vue&type=template&id=0834b722"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=0834b722&lang=scss&module=true"
cssModules["$style"] = style0
import "./Faq.vue?vue&type=style&index=1&id=0834b722&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__